import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import BrandListLayer from "../components/BrandListLayer";

const BrandListPage = () => {
    return (
        <MasterLayout>
            <BrandListLayer />
        </MasterLayout>
    );
};

export default BrandListPage;
